import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Foot, { Footer } from '../../../components/footer';
import GrHeader from '../../../components/grHeader';
import Qrcode from '../../../components/qrcode';
import LeftNav from '../layout/leftNav';
import RightOne from '../layout/rightOne';
import RightTwo from '../layout/rightTwo';
import RightThree from '../layout/rightThree';
import City from '../layout/city';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';

/**
 * for this page
 */

const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };
        state = {
            oneDisplay: true,
            twoDisplay: false,
            threeDisplay: false,
            navIndex: 0,
        };
        // 左侧导航点击定位
        handleLeftNav = num => {
            if (num === 0) {
                this.setState({
                    oneDisplay: true,
                    twoDisplay: false,
                    threeDisplay: false,
                });
            } else if (num === 1) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: true,
                    threeDisplay: false,
                });
            } else if (num === 2) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: false,
                    threeDisplay: true,
                });
            }
            this.setState({
                navIndex: num,
            });
        };
        render() {
            const { content } = this.props;

            const { header, qrCodeInfo, leftNav, rightOne, rightTwo, rightThree, city } = content;
            const { oneDisplay, twoDisplay, threeDisplay, navIndex } = this.state;

            return (
                <div>
                    <div className={styles.col}>
                        <GrHeader current={1} content={header} />
                        <div className={`${styles.mid_gy} clearfix`} style={{ marginBottom: '0' }}>
                            <div className={styles.mid_gy_left}>
                                <Chip id="80037" type="struct" title="左侧导航" groupName="关于校招" content={leftNav}>
                                    <LeftNav clickHandle={this.handleLeftNav} current={navIndex} />
                                </Chip>
                            </div>
                            <div className={styles.mid_gy_right}>
                                <Chip id="40122" type="static" title="招聘流程" groupName="关于校招" content={rightOne}>
                                    <RightOne show={oneDisplay} />
                                </Chip>
                                <Chip id="40165" type="static" title="招聘问答" groupName="关于校招" content={rightTwo}>
                                    <RightTwo show={twoDisplay} />
                                </Chip>
                                {/* <Chip
                                    id="40166"
                                    type="static"
                                    title="宣讲流程"
                                    groupName="关于校招"
                                    content={rightThree}>
                                    <RightThree show={threeDisplay} />
                                </Chip> */}
                                <div className={styles.tab_box} style={{ display: threeDisplay ? 'block' : 'none' }}>
                                    <div className={styles.map_mid}>
                                        <img
                                            src="//p3.ifengimg.com/a/2018/0810/493141e35f82041size158_w774_h657.png"
                                            alt=""
                                        />
                                        <Chip
                                            id="230037"
                                            type="struct"
                                            title="宣讲行程"
                                            groupName="关于校招"
                                            content={city}>
                                            <City />
                                        </Chip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    <Qrcode content={qrCodeInfo} />
                    <ChipEdit />
                </div>
            );
        }
    },
);

export { Layout };
export default Layout;
